import PropTypes from 'prop-types';

// material-ui
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// Project Imports
import MainCard from 'components-ts/cards/MainCard';

// ================================|| Unauthorised ||================================ //

const UnauthorisedErrorCard = ({ errorMessage = '' }) => (
  <Grid container direction="column" justifyContent="center">
    <Grid size={12}>
      <Grid container justifyContent="center" alignItems="center">
        <Grid sx={{ m: { xs: 1, sm: 3 }, mb: 0 }}>
          <Grid container spacing={2} alignItems="center" justifyContent="center">
            <Grid size={12}>
              <MainCard>
                <Box sx={{ p: 5, textAlign: 'center' }}>
                  <Typography variant="h3" sx={{ textAlign: 'center' }}>
                    {errorMessage}
                  </Typography>
                  <Typography sx={{ mt: 1 }}>Please contact your administrator to gain access.</Typography>
                </Box>
              </MainCard>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </Grid>
);

UnauthorisedErrorCard.propTypes = {
  errorMessage: PropTypes.string
};

export default UnauthorisedErrorCard;
